module.exports = __webpack_public_path__ + "static/media/apple_icon.9350f84d.png";